 document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-wrapper');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 50) {
      header.classList.add('scrolled-header');
    } else {
      header.classList.remove('scrolled-header');
    }
  });
});



